var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-button',{staticClass:"login-btn",attrs:{"round":"","disabled":_vm.disBtn,"loading":_vm.loading,"type":"primary"},on:{"click":function($event){return _vm.handle()}}},[_vm._v(_vm._s(_vm.btnStr))])
}
var staticRenderFns = []

export { render, staticRenderFns }